import { render } from "./MissionAndValueBody.vue?vue&type=template&id=6229eedb"
import script from "./MissionAndValueBody.vue?vue&type=script&lang=js"
export * from "./MissionAndValueBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__